export default __webpack_public_path__ + "static/media/enCamino.24ca67de.svg";